import { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useConvexAuth } from 'convex/react'
import { Spinner } from '../ui/Spinner'

/** Gate that requires an authenticated Convex Auth session. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { isLoading, isAuthenticated } = useConvexAuth()
  const location = useLocation()

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-zinc-950">
        <Spinner />
      </div>
    )
  }
  if (!isAuthenticated) {
    const next = encodeURIComponent(location.pathname + location.search)
    return <Navigate to={`/login?next=${next}`} replace />
  }
  return <>{children}</>
}
